import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";

export const LEAD_EMAIL_KEY = "ihmj_lead_email";

export default function StartPage() {
  const [email, setEmail] = useState(() => localStorage.getItem(LEAD_EMAIL_KEY) || "");
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/leads", { email: email.trim(), source: "start page" }, { timeout: 15000 });
      localStorage.setItem(LEAD_EMAIL_KEY, email.trim().toLowerCase());
      nav("/quiz");
    } catch (err) {
      toast.error(err?.response?.status === 422 ? "Please enter a valid email." : "Couldn't save that. Try again.");
      setBusy(false);
    }
  };

  return (
    <div className="min-h-[100svh] -mb-32 flex flex-col items-center justify-center px-6 py-6 text-center" data-testid="start-page">
      <img src="/logo.webp" alt="I Hate My Job" className="w-[44%] max-w-[240px] h-auto select-none" style={{ mixBlendMode: "lighten" }} draggable="false" data-testid="start-logo" />
      <h1 className="mt-5 font-display text-3xl sm:text-5xl font-black text-white leading-[1.08] max-w-xl" data-testid="start-headline">Your job shouldn't be a life sentence.</h1>
      <p className="mt-4 text-lg sm:text-xl text-gray-200 leading-snug max-w-xl" data-testid="start-line">Answer a few honest questions, and your AI coach finds a real business that fits your life, then walks you step by step to your first dollar.</p>
      <form onSubmit={submit} className="mt-6 w-full max-w-md space-y-3" data-testid="start-form">
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" autoComplete="email" inputMode="email"
          className="w-full bg-[#14161B] border border-[#2A2E39] rounded-lg px-4 py-4 text-lg text-white focus:border-[#FD0F10] outline-none" data-testid="start-email-input" />
        <button type="submit" disabled={busy} className="w-full hero-accent text-white font-display font-black text-xl py-4 rounded-lg disabled:opacity-60" data-testid="start-submit-btn">
          {busy ? "One sec..." : "Start Free"}
        </button>
      </form>
      <p className="mt-3 text-xs text-gray-400 max-w-md" data-testid="start-fineprint">Free to start and look around. Full 24/7 AI coach access is 19 USD/month. No spam.</p>
    </div>
  );
}
